import React, { useState } from "react";
import {
  Image,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Sidebar = (props) => {
  const location = useLocation();
  const profile = useSelector((state) => state.admin.profile);

  return (
    <>
      <div className={`admin-ui-sidebar`}>
        <div className="admin-ui-sidebar-collapse">
          <div className="admin-ui-collapse-logo-sec">
            <div className="admin-user-details">
              <Image
                className="admin-user-img"
                src={window.location.origin + "/logo192.png"}
              />
            </div>
          </div>
          <div className="admin-ui-collapse-body">
            <ul className="admin-ui-sidebar-list list-unstyled">
              <li>
                <Link
                  to="/"
                  className={`${location.pathname === "/" && "active"}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="#111"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.667"
                      d="M17.5 12.841v2.992a1.666 1.666 0 01-1.666 1.667h-2.992a1.175 1.175 0 01-.834-2.009l3.476-3.475a1.176 1.176 0 012.016.825zM5.417 8.333a2.917 2.917 0 100-5.833 2.917 2.917 0 000 5.833zM15.833 2.5h-2.5c-.92 0-1.666.746-1.666 1.667v2.5c0 .92.746 1.666 1.666 1.666h2.5c.92 0 1.667-.746 1.667-1.666v-2.5c0-.92-.746-1.667-1.667-1.667zM6.667 11.667h-2.5c-.92 0-1.667.746-1.667 1.666v2.5c0 .92.746 1.667 1.667 1.667h2.5c.92 0 1.666-.746 1.666-1.667v-2.5c0-.92-.746-1.666-1.666-1.666z"
                    ></path>
                  </svg>
                </Link>
              </li>
              {profile.data.kyc_status == 3 && (
                <React.Fragment>
                  <li>
                    <Link
                      to="/transactions"
                      className={`${
                        location.pathname.includes(
                          "transactions"
                        ) && "active"
                      }`}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 20 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.5 9.16665C2.5 5.70968 2.5 3.9812 3.47631 2.90725C4.45262 1.83331 6.02397 1.83331 9.16667 1.83331H10.8333C13.976 1.83331 15.5474 1.83331 16.5237 2.90725C17.5 3.9812 17.5 5.70968 17.5 9.16665V12.8333C17.5 16.2902 17.5 18.0188 16.5237 19.0927C15.5474 20.1666 13.976 20.1666 10.8333 20.1666H9.16667C6.02397 20.1666 4.45262 20.1666 3.47631 19.0927C2.5 18.0188 2.5 16.2902 2.5 12.8333V9.16665Z"
                          stroke="#252525"
                          stroke-width="2"
                        />
                        <path
                          d="M13.3334 8.91665H6.66675M6.66675 8.91665L8.95841 6.83331M6.66675 8.91665L8.95841 11"
                          stroke="#252525"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6.66675 13.0833H13.3334M13.3334 13.0833L11.0417 11M13.3334 13.0833L11.0417 15.1667"
                          stroke="#252525"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/customise-payment"
                      className={`${
                        location.pathname.includes("customise-payment") &&
                        "active"
                      }`}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.7193 10.6329C18.1883 10.0209 17.2631 10.0209 16.7326 10.6329L13.0435 14.8842V17.1739H15.0301L18.7188 12.9226C18.9843 12.6166 19.1304 12.2102 19.1304 11.7774C19.1304 11.3446 18.9843 10.9383 18.7193 10.6329ZM18.0568 12.159L14.6425 16.0946H13.9799V15.331L17.3947 11.3959C17.5712 11.1919 17.8798 11.1919 18.0568 11.3959C18.1453 11.4974 18.194 11.6328 18.194 11.7774C18.194 11.9221 18.1453 12.057 18.0568 12.159Z"
                          fill="black"
                          stroke="black"
                          stroke-width="0.5"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M4.14468 1H15.0615C16.8664 1 18.3365 2.59285 18.3365 4.54842V8.53447C18.099 8.46417 17.8562 8.40927 17.6088 8.37075V7.3083H1.59742V14.7994C1.59742 16.3213 2.74004 17.5593 4.14468 17.5593H10.626C10.6908 17.8287 10.7686 18.0919 10.8587 18.3478H4.14468C2.33976 18.3478 0.869629 16.755 0.869629 14.7994V4.54842C0.869629 2.59285 2.33976 1 4.14468 1ZM15.0615 1.78854H4.14468C2.74004 1.78854 1.59742 3.02654 1.59742 4.54842V6.51976H17.6088V4.54842C17.6088 3.02654 16.4661 1.78854 15.0615 1.78854Z"
                          fill="black"
                        />
                        <path
                          d="M18.3365 8.53447L18.1946 9.01391L18.8365 9.2039V8.53447H18.3365ZM17.6088 8.37075H17.1088V8.79893L17.5318 8.8648L17.6088 8.37075ZM17.6088 7.3083H18.1088V6.8083H17.6088V7.3083ZM1.59742 7.3083V6.8083H1.09742V7.3083H1.59742ZM10.626 17.5593L11.1122 17.4424L11.0201 17.0593H10.626V17.5593ZM10.8587 18.3478V18.8478H11.5648L11.3304 18.1818L10.8587 18.3478ZM1.59742 6.51976H1.09742V7.01976H1.59742V6.51976ZM17.6088 6.51976V7.01976H18.1088V6.51976H17.6088ZM15.0615 0.5H4.14468V1.5H15.0615V0.5ZM18.8365 4.54842C18.8365 2.3552 17.1795 0.5 15.0615 0.5V1.5C16.5533 1.5 17.8365 2.83049 17.8365 4.54842H18.8365ZM18.8365 8.53447V4.54842H17.8365V8.53447H18.8365ZM17.5318 8.8648C17.757 8.89986 17.9782 8.94984 18.1946 9.01391L18.4785 8.05503C18.2199 7.9785 17.9553 7.91868 17.6857 7.8767L17.5318 8.8648ZM17.1088 7.3083V8.37075H18.1088V7.3083H17.1088ZM1.59742 7.8083H17.6088V6.8083H1.59742V7.8083ZM2.09742 14.7994V7.3083H1.09742V14.7994H2.09742ZM4.14468 17.0593C3.05317 17.0593 2.09742 16.0836 2.09742 14.7994H1.09742C1.09742 16.5589 2.42692 18.0593 4.14468 18.0593V17.0593ZM10.626 17.0593H4.14468V18.0593H10.626V17.0593ZM11.3304 18.1818C11.246 17.942 11.173 17.6953 11.1122 17.4424L10.1399 17.6761C10.2086 17.9621 10.2913 18.2417 10.3871 18.5138L11.3304 18.1818ZM4.14468 18.8478H10.8587V17.8478H4.14468V18.8478ZM0.369629 14.7994C0.369629 16.9926 2.02663 18.8478 4.14468 18.8478V17.8478C2.65289 17.8478 1.36963 16.5173 1.36963 14.7994H0.369629ZM0.369629 4.54842V14.7994H1.36963V4.54842H0.369629ZM4.14468 0.5C2.02663 0.5 0.369629 2.3552 0.369629 4.54842H1.36963C1.36963 2.83049 2.65289 1.5 4.14468 1.5V0.5ZM4.14468 2.28854H15.0615V1.28854H4.14468V2.28854ZM2.09742 4.54842C2.09742 3.26419 3.05317 2.28854 4.14468 2.28854V1.28854C2.42692 1.28854 1.09742 2.7889 1.09742 4.54842H2.09742ZM2.09742 6.51976V4.54842H1.09742V6.51976H2.09742ZM17.6088 6.01976H1.59742V7.01976H17.6088V6.01976ZM17.1088 4.54842V6.51976H18.1088V4.54842H17.1088ZM15.0615 2.28854C16.153 2.28854 17.1088 3.26419 17.1088 4.54842H18.1088C18.1088 2.7889 16.7793 1.28854 15.0615 1.28854V2.28854Z"
                          fill="black"
                        />
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/account-settings"
                      className={`${
                        location.pathname.includes("account-settings") &&
                        "active"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 20 20"
                      >
                        <g
                          stroke="#111"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          clipPath="url(#clip0_33_435)"
                        >
                          <path d="M4.756 2.678l1.402-.782a1.759 1.759 0 011.315-.173c.22.057.427.156.607.291.181.135.333.303.446.496.15.266.37.488.639.643a1.773 1.773 0 001.772 0c.268-.155.488-.377.638-.643.232-.387.61-.668 1.054-.783a1.779 1.779 0 011.314.169l1.392.782c.198.113.37.263.508.442a1.664 1.664 0 01.325 1.26c-.035.221-.114.433-.233.623a1.658 1.658 0 00.003 1.689c.153.256.371.47.635.618.263.148.562.226.866.227.46.003.898.182 1.222.5.324.316.506.745.506 1.192v1.574c0 .446-.182.874-.506 1.19a1.752 1.752 0 01-1.222.492 1.764 1.764 0 00-.871.222 1.708 1.708 0 00-.639.619 1.649 1.649 0 00.006 1.693c.229.387.291.847.173 1.28a1.699 1.699 0 01-.803 1.026l-1.403.782a1.758 1.758 0 01-1.317.168 1.743 1.743 0 01-.607-.294 1.697 1.697 0 01-.444-.498 1.714 1.714 0 00-.638-.643 1.774 1.774 0 00-1.772 0 1.714 1.714 0 00-.638.643c-.232.386-.61.667-1.054.782a1.778 1.778 0 01-1.314-.168l-1.403-.782a1.7 1.7 0 01-.809-1.024c-.12-.433-.06-.893.17-1.282a1.658 1.658 0 00-.004-1.688 1.715 1.715 0 00-.635-.618 1.774 1.774 0 00-.866-.228c-.46 0-.9-.176-1.225-.492a1.67 1.67 0 01-.513-1.19V9.219a1.701 1.701 0 01.526-1.208 1.79 1.79 0 011.252-.484c.306.003.606-.072.87-.219.266-.146.487-.358.64-.614a1.649 1.649 0 00.005-1.69 1.654 1.654 0 01-.187-1.292c.058-.217.16-.42.301-.598.14-.177.316-.326.516-.436z"></path>
                          <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_33_435">
                            <path fill="#fff" d="M0 0H20V20H0z"></path>
                          </clipPath>
                        </defs>
                      </svg>
                    </Link>
                  </li>
                </React.Fragment>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
